import React, { Component, useDebugValue } from 'react';
import { Link } from 'react-router';
import { Row, Col } from 'reactstrap';
// import { FieldCol, FieldGroup, FieldLabel, FieldInput, FieldSelect, FieldTextarea, FieldDate} from '../../Elements';
import { leaseTypeDrpdwn } from '../../../../constants';
import {checkString} from '../../../../formValidator'
import { jetStreamInstance } from '../../../Leases';
import { FieldCol, FieldGroup, FieldInput, FieldLabel, FieldSelect, FieldTextarea } from '../../../../applications/contracts/Elements';
import { avationPlcInstance, leshaBankInstance, mtInstance } from '../../../../shared_elements/components';
export default class EditWetleaseCard extends Component{
  constructor(props){
    super(props);
    this.state = {
      wetleasecard: {},
      error: {}
    }
  }
  componentDidMount(){
    this.updateHdState(this.props.wetleasecard);
  }
  updateHdState = (wetleasecard) => {
    let data = Object.assign({}, wetleasecard);
    this.setState({
        wetleasecard: data
    });
  }
  updateForm = (type, value) => {
    if(['wetlease_fee','right_wetlease_without_approval','wetlease_comment'].includes(type)){
      this.setState(prevState => ({
        wetleasecard: {
          ...prevState.wetleasecard,
          titan_extra_fields: {
            ...prevState.wetleasecard?.titan_extra_fields,
            [type]: value,
          },
        },
      }));
    }
  }
  updateWetLeaseCard = (e) => {
    e.preventDefault();
    const titan_extra_fields = { ...this.state.wetleasecard.titan_extra_fields };
    this.props.updateWetLeaseCard({ titan_extra_fields });
  }
  render(){
    const { type, portfolioList, ownerList } = this.props;
    const { error, wetleasecard } = this.state;
      return(
        <form onSubmit={(e) => this.updateWetLeaseCard(e)}>
          <div style={{ height: (window.innerHeight - 157) + 'px', overflow:'auto',marginBottom:'60px' }}>
            <Row>
              <FieldCol md="12">
                  <FieldGroup className="form-group">
                    <FieldLabel className="label">Right to Wet Lease without prior Approval</FieldLabel>
                    <FieldSelect
                      placeholder='Select YES/NO'
                      keyParam="right_wetlease_without_approval"
                      value={wetleasecard?.titan_extra_fields?.right_wetlease_without_approval || ''}
                      type={type}
                      options={[{ label: 'YES', value: 'YES' },{ label: 'NO', value: 'NO' }]}
                      updateField={this.updateForm}
                      labelKey='label'
                      valueKey='value'
                    />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                  <FieldGroup className="form-group">
                    <FieldLabel className="label">Wet Lease Fee</FieldLabel>
                    <FieldSelect
                      placeholder='Select YES/NO'
                      keyParam="wetlease_fee"
                      value={wetleasecard?.titan_extra_fields?.wetlease_fee || ''}
                      type={type}
                      options={[{ label: 'YES', value: 'YES' },{ label: 'NO', value: 'NO' }]}
                      updateField={this.updateForm}
                      labelKey='label'
                      valueKey='value'
                    />
                </FieldGroup>
              </FieldCol>
            </Row>
            {(mtInstance || avationPlcInstance || leshaBankInstance) ?
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Wet Lease Comment</FieldLabel>
                  <FieldTextarea
                    value={wetleasecard?.titan_extra_fields?.wetlease_comment || ''}
                    type={type}
                    ro
                    keyParam="wetlease_comment"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>:null}
         </div>
         <div className="submit-block">
           <input type="submit" className="primary-btn" value="Save Changes"/>
           <Link onClick={() => this.props.toggleEditSideBar()} >Cancel</Link>
         </div>
       </form>
      )
  }
}
